<template>
    <div class="field">
        <p :class="classes">
            <label :for="id" class="label" v-html="label" v-if="['checkbox'].indexOf(type) === -1"></label>
            <form-control :id="id"
                          :placeholder="placeholder"
                          :type="type"
                          :value="value"
                          :true-value="trueValue"
                          :false-value="falseValue"
                          :required="required"
                          :mask="mask"
                          :save-mask="saveMask"
                          :options="options"
                          :option_name="option_name"
                          :option_value="option_value"
                          @input="updateInput"
                          @event="passEvent"
                          ref="form_control">
                <span slot="label" v-html="label"></span>
                <transition name="expand-extra-tiny">
                    <small class="form-info" v-if="error">
                        <ul>
                            <li v-for="text in error">
                                {{ text }}

                            </li>
                        </ul>
                    </small>
                </transition>
            </form-control>
            <slot></slot>
        </p>
    </div>
</template>

<style lang="scss" ref="stylesheet/scss">
    label.label {
        font-weight: bold;
    }

    label.checkbox {
        font-weight: normal;
    }

    input.input {
        font-weight: normal;
    }

    select.input {
      font-weight: normal;
    }

    textarea.textarea {
        font-weight: normal;
    }


    .form-error {
        .input {
            border-color: #D93037;
        }
    }

    .form-info {
        color: #D93037;
        font-size: 1rem;
        ul {
            margin: 0.5rem auto;
            padding: 0;
            list-style: none;
        }
    }
</style>

<script>
    export default {
        name: 'FormGroup',
        props: [
            'id',
            'type', 'value', 'trueValue', 'falseValue', 'error', // input type and value, trueValue/falseValue for checkboxes/radios
            'label', 'placeholder', // regular labels, floating-placeholder-labels, regular placeholders
            'options', 'option_value', 'option_name', // select options
            'mask', 'saveMask', // input masking
            'disabled', 'required'
        ],
        computed: {
            classes() {
                let filled = (this.value !== null && this.value !== '') ? ' filled' : '';
                let error  = (typeof this.error === 'undefined' || this.error === null) ? '' : ' form-error';
                return 'control ' + filled + error;
            }
        },
        methods: {
            updateInput(value = this.$refs.form_control.tempValue) {
                this.$emit('input', value)
            },
            passEvent(event) {
                this.$emit('event', event)
            }
        }
    };
</script>



// WEBPACK FOOTER //
// FormGroup.vue?58109626